'use client'
import { createContext, useContext, useEffect, useRef, useState, useCallback } from 'react'
import { SOCKET_URL } from '../../Api/apis'

interface SocketContextType {
  socket: WebSocket | null
  subscribe: (callback: (data: any) => void) => void
  unsubscribe: (callback: (data: any) => void) => void
}

const SocketContext = createContext<SocketContextType>({} as SocketContextType)

export const useSocket = () => {
  return useContext(SocketContext)
}

export const SocketProvider = ({ children }: { children: React.ReactNode }) => {
  const socketRef = useRef<WebSocket | null>(null)
  const subscribers = useRef<((data: any) => void)[]>([])
  const [isConnected, setIsConnected] = useState(false)

  const handleMessage = useCallback((event: MessageEvent) => {
    try {
      const data = JSON.parse(event.data)
      subscribers.current.forEach(callback => callback(data))
    } catch (error) {
      console.error('Error parsing WebSocket message:', error)
    }
  }, [])

  const subscribe = useCallback((callback: (data: any) => void) => {
    subscribers.current.push(callback)
  }, [])

  const unsubscribe = useCallback((callback: (data: any) => void) => {
    subscribers.current = subscribers.current.filter(cb => cb !== callback)
  }, [])

  useEffect(() => {
    const connectWebSocket = () => {
      const socket = new WebSocket(SOCKET_URL)
      socketRef.current = socket

      socket.onopen = (event) => {
           console.log('webSocket connected'); 
           
        setIsConnected(true)
        
        const message = {
          event_name: "subscribe",
          data: {
            channels: [],
            last: 0
          }
        }
        socket.send(JSON.stringify(message))
      }

      socket.onmessage = handleMessage

      socket.onclose = (event) => {
        
        setIsConnected(false)
        connectWebSocket()
      }

      socket.onerror = (error) => {
        console.error('WebSocket error:', error)
      }
    }

    connectWebSocket()

    return () => {
      if (socketRef.current) {
        socketRef.current.close()
        socketRef.current = null
      }
    }
  }, [handleMessage])

  return (
    <SocketContext.Provider value={{ 
      socket: socketRef.current, 
      subscribe,
      unsubscribe
    }}>
      {children}
    </SocketContext.Provider>
  )
}